import { render, staticRenderFns } from "./PaidMobile.vue?vue&type=template&id=78894498&scoped=true&"
import script from "./PaidMobile.vue?vue&type=script&lang=js&"
export * from "./PaidMobile.vue?vue&type=script&lang=js&"
import style0 from "./PaidMobile.vue?vue&type=style&index=0&id=78894498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78894498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78894498')) {
      api.createRecord('78894498', component.options)
    } else {
      api.reload('78894498', component.options)
    }
    module.hot.accept("./PaidMobile.vue?vue&type=template&id=78894498&scoped=true&", function () {
      api.rerender('78894498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_adguard_landing/components/PaidModal/PaidMobile.vue"
export default component.exports